import { render, staticRenderFns } from "./product-header.vue?vue&type=template&id=570a395d"
import script from "./product-header.vue?vue&type=script&lang=js"
export * from "./product-header.vue?vue&type=script&lang=js"
import style0 from "./product-header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports